/** URL do backend — em produção defina VITE_API_URL (ex.: https://seu-dominio.com ou Cloud Function). */
export const API_BASE = (import.meta.env.VITE_API_URL || 'http://localhost:3000').replace(/\/$/, '')

export function apiUrl(path) {
  const p = path.startsWith('/') ? path : `/${path}`
  return `${API_BASE}${p}`
}
